import { IUrlPathConstructor } from '../../interfaces';
import { Filter } from '../filter';
import { FilterDefinition } from '../definition';

export class UrlPathConstructor implements IUrlPathConstructor {
	public extractUrlPathPart(filter: Filter): string {
		if (filter.values.length !== 1) {
			return '';
		}

		const option = filter.values[0];
		const filterDefinition = filter.definition;
		if (filterDefinition !== undefined) {
			return this.findUrlPathForOption(option, filterDefinition);
		}

		return '';
	}

	private findUrlPathForOption(option: string, filterDefinition: FilterDefinition): string {
		if (filterDefinition.indexableFilterOptionValues.includes(option)) {
			return filterDefinition.filterInformation.filter((_) => _.optionValue === option)[0].optionPath;
		}

		return '';
	}
}
